import { render, staticRenderFns } from "./InvestProgressBar.vue?vue&type=template&id=521ed1b6&scoped=true&"
import script from "./InvestProgressBar.vue?vue&type=script&lang=js&"
export * from "./InvestProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521ed1b6",
  null
  
)

export default component.exports